exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-daafb36a]{background-color:#333;width:70%;margin:auto;border-radius:10px}p>span[data-v-daafb36a]{font-size:40px;color:#fff}.lightbox[data-v-daafb36a]{background:rgba(0,0,0,.8)}.carousel-control-next[data-v-daafb36a],.carousel-control-prev[data-v-daafb36a]{width:50px;background-color:rgba(22,153,77,.8);height:50px;margin-top:15rem!important}.opacity[data-v-daafb36a]{transition:opacity 1s ease}.opacity[data-v-daafb36a]:hover{opacity:.5;transition:opacity 1s ease}.before-enter[data-v-daafb36a]{opacity:0;transform:scale(0);transition:all .5s ease-in}.enter[data-v-daafb36a]{opacity:1;transform:scale(1)}@media only screen and (max-width:600px){#galeri[data-v-daafb36a]{margin-top:5rem;width:500px;height:250px}}@media only screen and (min-width:600px){#galeri[data-v-daafb36a]{width:700px;height:500px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-daafb36a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Galery.vue
// module id = 179
// module chunks = 0